import { createStore } from 'stimulus-store';

/**
 * Store for all available actions in the organization
 *
 * This store is populated by the all_actions_supplier_controller on page load
 * and provides instant access to the complete actions list for the permissions modal.
 *
 * Structure:
 * {
 *   lastRefreshTime: '2024-01-27T10:30:45.123Z',   // ISO timestamp of last successful load
 *   initialLoadComplete: false,                    // true after first successful load
 *   actions: [
 *     {
 *       identifier: 'items:create',                // Unique action identifier
 *       description: 'Create a device',            // Human-readable description (searchable)
 *       category: 'Device Management',             // Grouping category
 *       public: false                              // If true, implicitly granted (filtered out)
 *     }
 *   ]
 * }
 */
export const allActionsStore = createStore({
    name: 'allActionsStore',
    type: Object,
    initialValue: {
        lastRefreshTime: null,
        initialLoadComplete: false,
        actions: []
    }
});
